import type {
    NeglectedOrDelinquentPeriodCountsModel,
} from './NeglectedOrDelinquentInformationModel';

export const PERIOD_COUNT_FIELDS: {
    key: keyof NeglectedOrDelinquentPeriodCountsModel;
    label: string;
}[] = [
    { key: 'whileInProgram', label: 'While in the program' },
    { key: 'within90DaysOfExiting', label: 'Within 90 Days of Exiting' },
];
